import { Tag } from "antd"

export function useRemainingDaysTag({ createdAt, status }) {
  if (status !== "CREATED") return null

  const startDate = new Date( createdAt)
  const now = new Date();
  const diffInMs = now - startDate;
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))
  const remainingDays = 60 - diffInDays;

  if (remainingDays <= 0) {
   
    return <Tag color="red">Solicitud vencida</Tag>
  }

  const color = remainingDays <= 15 ? "orange" : "green"
  return (
    <Tag color={color}>
    {remainingDays} día{remainingDays === 1 ? "" : "s"}
    </Tag>
  )
}